<table class="tiime-table" aria-label="Tableau prestations">
  <thead>
    <tr tiimeTableHeaderRow>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="task">Prestation</th>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="label">Intitulé Imprimé</th>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="amountExcludingTaxed">Montant HT</th>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="periodicity">Fréq. fac.</th>
      <th tiimeTableHeaderCell="actions"></th>
    </tr>
  </thead>
  <tbody>
    @for (
      prestationForm of prestationForms | prestationsGroupByOffer;
      track trackByFormId(i, prestationForm);
      let i = $index
    ) {
      @if (withHeader() && (prestationForm | map: mapToDisplayOfferRow : i)) {
        <tr tiimeTableRow>
          <td colspan="4" tiimeTableCell="offer">
            @if (prestationForm.contractOffer.value?.offer?.id; as modelOfferId) {
              Modèle : {{ prestationForm.contractOffer.value?.label }}
              <button
                [disabled]="prestationForm.disabled"
                type="button"
                class="remove-model-offer-btn"
                tiime-button
                icon
                color="primary"
                tabindex="-1"
                tiimeTooltip="Retirer le modèle d'offre et ses éléments liés"
                (click)="emitRemoveModelOffer(modelOfferId)"
              >
                <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
              </button>
            } @else {
              Autres prestations
            }
          </td>
        </tr>
      }
      <tr tiimeTableRow [formGroup]="prestationForm">
        <td tiimeTableCell="task">
          <app-time-trackings-task-select
            [control]="prestationForm.task"
            [tasks]="tasks"
            [small]="true"
            label=""
            (selectionChange)="taskChange(prestationForm, i)"
          ></app-time-trackings-task-select>
        </td>
        <td tiimeTableCell="label">
          <input #labelInput type="text" placeholder="Prestation" formControlName="label" />
        </td>
        <td tiimeTableCell="amountExcludingTaxed">
          <input
            appDigitOnly
            [decimal]="true"
            [roundDecimal]="false"
            placeholder="Montant HT"
            formControlName="amountExcludedTax"
          />
          @if (prestationForm.amountExcludedTaxErrorMessage) {
            <app-list-error [errorMessage]="prestationForm.amountExcludedTaxErrorMessage"></app-list-error>
          }
        </td>
        <td tiimeTableCell="periodicity">
          <app-periodicity-select
            label=""
            errorMessageMode="list"
            [small]="true"
            [selectData]="periodicities"
            [control]="prestationForm.periodicity"
            [errorMessage]="prestationForm.periodicityErrorMessage"
            (selectionChange)="periodicityChange(prestationForm)"
          ></app-periodicity-select>
        </td>
        <td tiimeTableCell="actions">
          @if (!prestationForm.hasDiscount) {
            <button
              [disabled]="prestationForm.disabled"
              type="button"
              class="show-on-hover"
              tiime-button
              icon
              color="primary"
              tabindex="-1"
              tiimeTooltip="Ajouter une remise"
              (click)="addPrestationDiscount(prestationForm)"
            >
              <mat-icon class="discount-icon" svgIcon="icon-percent"></mat-icon>
            </button>
          }
          <button
            [disabled]="prestationForm.disabled"
            type="button"
            class="show-on-hover"
            tiime-button
            icon
            color="primary"
            tabindex="-1"
            tiimeTooltip="Retirer la prestation"
            (click)="emitRemovePrestation(i)"
          >
            <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
          </button>
        </td>
      </tr>
      @if (prestationForm.hasDiscount) {
        <tr tiimeTableRow [formGroup]="prestationForm">
          <td tiimeTableCell="task">
            <div class="discount-label">
              <mat-icon class="discount-icon" fontSet="fontastic" fontIcon="icon-ic-arrow-inner"></mat-icon>
              Remise
              @if (prestationForm.periodicity.value !== 'unit') {
                <input
                  #discountOccurenceInput
                  class="discount-occurence-input"
                  appDigitOnly
                  [decimal]="false"
                  placeholder="Occurence"
                  formControlName="discountOccurrence"
                />
                @if (prestationForm.discountOccurrence.value) {
                  {{
                    prestationForm.periodicity.value | discountPeriodicityLabel: prestationForm.discountOccurrence.value
                  }}
                }
              }
            </div>
          </td>
          <td tiimeTableCell="label">
            <input type="text" placeholder="Complément imprimé" formControlName="discountPrintedLabel" />
          </td>
          <td tiimeTableCell="amountExcludingTaxed">
            <input
              appDigitOnly
              [decimal]="true"
              [roundDecimal]="false"
              placeholder="Montant HT"
              formControlName="discountAmount"
              [max]="prestationForm.amountExcludedTax.value"
            />
            @if (prestationForm.discountAmountErrorMessage) {
              <app-list-error [errorMessage]="prestationForm.discountAmountErrorMessage"></app-list-error>
            }
          </td>
          <td tiimeTableCell="periodicity"></td>
          <td tiimeTableCell="actions">
            <button
              [disabled]="prestationForm.disabled"
              type="button"
              class="show-on-hover"
              tiime-button
              icon
              color="primary"
              tabindex="-1"
              tiimeTooltip="Retirer la remise"
              (click)="removePrestationDiscount(prestationForm)"
            >
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
            </button>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
